import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'; import { MenuLateral } from '../MenuLateral/MenuLateral'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'; // Importa el icono faBars
import Nav from 'react-bootstrap/Nav';
import { fichaPower960, manualPower960, certificado } from '../../Archivos/power960';
import './Power960.css';

export function Power960() {

    const [fotoSeleccionada, setFotoSeleccionada] = useState(null);
    const [subtituloModal, setSubtituloModal] = useState("");

    const modalFoto = (foto, subtitulo) => {
        setFotoSeleccionada(foto);
        setSubtituloModal(subtitulo)
    };

    const logoPdf = <FontAwesomeIcon icon={faFilePdf} size="xl" style={{ color: "#006c87", }} />

    const abrirPdf = (archivo) => {
        window.open(archivo, '_blank');
    };

    const archivosPDF = {
        ficha: fichaPower960,
        manual: manualPower960,
        certificado: certificado

    };

    const clicEnlacePdf = (tipoArchivo) => {
        abrirPdf(archivosPDF[tipoArchivo]);
    };

    return (
        <>
            <div className="mainContainer">
                <MenuLateral />

                <div className='contenedorProducto'>
                    <div className='row'>
                        <div className='col-xl-3 col-lg-3 col-md-12 col-sm-12'>
                            <div className='imagenesPower960'>

                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoPower960"
                                            src={require("../Img/power960.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/power960.webp"), 'Cargador de Baterías Power-960')}
                                            alt='Cargador de Baterías Power-960' />
                                    </div>
                                </Row>

                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className='descripcionPower960'>
                                <h2 className='nombreProductoPower960'>Cargador de Baterías Power-960</h2>
                                <h5 className='tituloProductoPower960'>Cargador de baterías EN54-4 24V, 960W para sistemas de evacuación por voz.

                                </h5>
                                <p className='textoProductoPower960'>
                                    Diseñado para cargar baterías de plomo-ácido (alimentación de reserva para el sistema de evacuación por voz) y, al 
                                    mismo tiempo, ofrece alimentación para aplicaciones auxiliares.
                                    <br /><br />
                                    Incluye 2 salidas de carga (cada una a 480W) y una potencia máxima de 960W.
                                    <br /><br />
                                    Soporta 1 unidad NEO 8060 con 2 baterías de 45Ah 12V (no incluidas). Dimensiones (WxHxD): 482,6 x 89 x 244 mm, 
                                    2U. Peso: 3,1 kg.
                                    
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-12'>

                            <div className='contenedorNavPower960'>
                                <Nav as="ul" className="flex-column">
                                    <Nav.Item className='linksArchivosPower960' as="li" onClick={() => clicEnlacePdf('ficha')}>
                                        {logoPdf}
                                        Ficha Cargador de Baterías Power-960
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosPower960' as="li" onClick={() => clicEnlacePdf('manual')}>
                                        {logoPdf}
                                        Manual Cargador de Baterías Power-960
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosPower960' as="li" onClick={() => clicEnlacePdf('certificado')}>
                                        {logoPdf}
                                        Certificado en 54-16
                                    </Nav.Item>

                                </Nav>
                            </div>
                        </div>
                    </div>

                </div>

            </div >

            <Modal className='imgModalContainer' show={fotoSeleccionada !== null} onHide={() => setFotoSeleccionada(null)}>
                <Modal.Header closeButton>
                    {subtituloModal && <Modal.Title>{subtituloModal}</Modal.Title>}
                </Modal.Header>
                <Modal.Body>
                    {fotoSeleccionada && (<img src={fotoSeleccionada} alt="Foto Cargador de Baterías Power-960" className="imgModal" />)}
                </Modal.Body>
            </Modal>

        </>
    );

}

